import React from "react";
import PropTypes from "prop-types";
import styles from "./MainNav.module.less";

const EnterpriseDashboardIcon = ({ width = "26", height = "19", fill = "white", active = false, hovered = false }) => {
  return (
    <div
      className={[active ? styles.navIconContainerActive : styles.navIconContainer, hovered ? styles.hovered : []].join(
        " ",
      )}
      style={{
        paddingTop: "1px",
      }}
    >
      <svg
        width={height}
        height={width}
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.enterpriseIcon}
      >
        <rect
          x="0.834375"
          y="0.799219"
          width="19.3"
          height="19.3"
          rx="9.65"
          fill="var(--royal-peacock-blue)"
          stroke="var(--royal-peacock-blue)"
          strokeWidth="0.7"
        />
        <path
          className={styles.path}
          d="M5.78823 5.12891H15.18C15.5258 5.12891 15.8061 5.40923 15.8061 5.75503V9.51174C15.8061 9.85753 15.5258 10.1379 15.18 10.1379H5.78823C5.44243 10.1379 5.16211 9.85753 5.16211 9.51174V5.75503C5.16211 5.40923 5.44243 5.12891 5.78823 5.12891ZM6.6808 9.02222L7.85213 8.58296L9.48894 8.88056C9.55169 8.89197 9.61642 8.88395 9.67449 8.85756L11.2934 8.12168L12.9062 8.56152C13.0013 8.58745 13.103 8.56711 13.1808 8.50661L14.5896 7.4109C14.726 7.30475 14.7506 7.10807 14.6445 6.97159C14.5383 6.83511 14.3416 6.81053 14.2052 6.91668L12.92 7.91629L11.3491 7.48789C11.2787 7.46867 11.2037 7.47469 11.1372 7.50491L9.50457 8.24702L7.87911 7.95149C7.82348 7.94138 7.76614 7.94651 7.71319 7.96637L6.46096 8.43596C6.29907 8.49667 6.21704 8.67713 6.27775 8.83902C6.33846 9.0009 6.51891 9.08293 6.6808 9.02222ZM8.2927 7.16379H9.858C10.0309 7.16379 10.1711 7.02363 10.1711 6.85073C10.1711 6.67784 10.0309 6.53767 9.858 6.53767H8.2927C8.11981 6.53767 7.97964 6.67784 7.97964 6.85073C7.97964 7.02363 8.11981 7.16379 8.2927 7.16379ZM6.88394 7.32032C7.14328 7.32032 7.35353 7.11008 7.35353 6.85073C7.35353 6.59139 7.14328 6.38114 6.88394 6.38114C6.62459 6.38114 6.41435 6.59139 6.41435 6.85073C6.41435 7.11008 6.62459 7.32032 6.88394 7.32032ZM5.78823 10.764H9.54494C9.89074 10.764 10.1711 11.0443 10.1711 11.3901V15.1468C10.1711 15.4926 9.89074 15.7729 9.54494 15.7729H5.78823C5.44243 15.7729 5.16211 15.4926 5.16211 15.1468V11.3901C5.16211 11.0443 5.44243 10.764 5.78823 10.764ZM8.44923 13.2685C8.44923 13.7007 8.09883 14.0511 7.66658 14.0511C7.23434 14.0511 6.88394 13.7007 6.88394 13.2685C6.88394 12.8362 7.23434 12.4858 7.66658 12.4858C7.83948 12.4858 7.97964 12.3456 7.97964 12.1727C7.97964 11.9998 7.83948 11.8597 7.66658 11.8597C6.88854 11.8597 6.25782 12.4904 6.25782 13.2685C6.25782 14.0465 6.88854 14.6772 7.66658 14.6772C8.44463 14.6772 9.07535 14.0465 9.07535 13.2685C9.07535 13.0956 8.93519 12.9554 8.76229 12.9554C8.58939 12.9554 8.44923 13.0956 8.44923 13.2685ZM11.4233 10.764H15.18C15.5258 10.764 15.8061 11.0443 15.8061 11.3901V15.1468C15.8061 15.4926 15.5258 15.7729 15.18 15.7729H11.4233C11.0775 15.7729 10.7972 15.4926 10.7972 15.1468V11.3901C10.7972 11.0443 11.0775 10.764 11.4233 10.764ZM12.3938 13.3624L12.8651 13.0089L13.3182 13.2354C13.4294 13.291 13.563 13.2755 13.6586 13.1959L14.5978 12.4132C14.7306 12.3026 14.7485 12.1051 14.6379 11.9723C14.5272 11.8395 14.3298 11.8216 14.1969 11.9322L13.4151 12.5838L12.9721 12.3623C12.866 12.3093 12.7391 12.3207 12.6442 12.3919L12.0181 12.8615C11.8798 12.9652 11.8518 13.1614 11.9555 13.2998C12.0592 13.4381 12.2555 13.4661 12.3938 13.3624ZM12.6755 14.5207H13.9278C14.1007 14.5207 14.2408 14.3805 14.2408 14.2076C14.2408 14.0347 14.1007 13.8946 13.9278 13.8946H12.6755C12.5026 13.8946 12.3625 14.0347 12.3625 14.2076C12.3625 14.3805 12.5026 14.5207 12.6755 14.5207Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};

EnterpriseDashboardIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string,
  active: PropTypes.bool,
  hovered: PropTypes.bool,
};

export default EnterpriseDashboardIcon;
